import React, { Suspense, useEffect, useState } from "react";
import styles from "./css/index.module.css";
import { useParams } from "react-router";
import rDData from "./data/r&dexhibit.json";
import startUpData from "./data/startup.json";
import MoreInfoModal from "./modal";
import Modal from "../../components/modal";
const VideoModal = React.lazy(() => import("./components/VideoModal"));

const RDExhibit = () => {
    const { type } = useParams();

    useEffect(() => {
        setData(rDData);
        setTabDefaultState();
    }, [type]);

    const [data, setData] = useState([]);
    const [modalContent, setModalContent] = useState({});
    const [showModel, setShowModel] = useState(false);
    const [showVideoPopup, setVideoPopup] = useState(false);
    const toggleModel = () => setShowModel(!showModel);
    const toggleVideoPopup = () => setVideoPopup(!showVideoPopup);
    const [tab, setTab] = useState(1);

    const setTabDefaultState = () => {
        switch (type) {
            case "r&d-pavilion":
                setTab(1);
                break;
            case "start-up-pavilion":
                setTab(2);
                break;
            default:
                setTab(1);
                break;
        }
    };

    return (
        <section className={styles.container_wrapper}>
            <div className={styles.container_title}>
                CONFERENCE <span>SHOWCASE</span>
                {/* MEET OUR <span>PAVILION</span> */}
            </div>
            <div className={styles.container_sub_title}>
                Meet C3iHub R&D and Start-ups doing cutting-edge research and innovation at CCETC Showcase Pavilion. Explore interactive exhibits, and live demonstrations of indigenous cybersecurity
                products that are poised to safeguard the future of digital safety in India
            </div>
            <button onClick={toggleVideoPopup} className={styles.playBtn}></button>

            <div className={styles.tab}>
                <p onClick={() => setTab(1)} className={tab === 1 && styles.active}>
                    R&D SHOWCASE
                </p>
                <p onClick={() => setTab(2)} className={tab === 2 && styles.active}>
                    START-UP PAVILION
                </p>
            </div>
            <div className={styles.grid}>
                {tab === 1 &&
                    data?.map((item, index) => {
                        return (
                            <div className={styles.grid_item} key={index}>
                                <div className={styles.details}>
                                    <p>
                                        <span>Name:</span> {item.name}{" "}
                                        <a title="INSTITUTE HOME PAGE" href={item.instituteHomePage} target="_blank" rel="noopener noreferrer">
                                            {" "}
                                            <svg xmlns="http://www.w3.org/2000/svg" width="1.2em" height="1.2em" viewBox="0 0 24 24">
                                                <g fill="none" stroke="currentColor" stroke-width="1.5">
                                                    <path stroke-linecap="round" stroke-linejoin="round" d="M22 12c0-5.523-4.477-10-10-10S2 6.477 2 12s4.477 10 10 10" />
                                                    <path stroke-linecap="round" stroke-linejoin="round" d="M13 2.05S16 6 16 12m-5 9.95S8 18 8 12s3-9.95 3-9.95M2.63 15.5H12m-9.37-7h18.74" />
                                                    <path
                                                        d="M21.879 17.917c.494.304.463 1.043-.045 1.101l-2.567.291l-1.151 2.312c-.228.459-.933.234-1.05-.334l-1.255-6.116c-.099-.48.333-.782.75-.525z"
                                                        clip-rule="evenodd"
                                                    />
                                                </g>
                                            </svg>
                                        </a>
                                    </p>
                                    <p>
                                        <span>Institute Name:</span> {item.instituteName}
                                    </p>
                                    <p>
                                        <span>Project Title:</span> {item.projectTitle}
                                    </p>
                                </div>
                                <button
                                    onClick={() => {
                                        setModalContent(item);
                                        toggleModel();
                                    }}
                                >
                                    More info
                                </button>
                            </div>
                        );
                    })}
            </div>

            {tab === 2 &&
                startUpData.map((section, index) => (
                    <div key={index}>
                        <h3 className={styles.section_name}>{section.name}</h3>
                        <div className={`${styles.grid} ${styles.startup_grid}`}>
                            {section.data.map((item, index) => (
                                <div className={styles.grid_item} key={index}>
                                    <a href={item.url} target="_blank" rel="noopener noreferrer">
                                        <img className={styles[`logo_${index + 1}`]} src={`${require(`./images/${section.basePath}/${item.logo}`)}`} alt={item.logo} />
                                    </a>
                                </div>
                            ))}
                        </div>
                    </div>
                ))}

            {showModel && <MoreInfoModal data={modalContent} onClose={toggleModel} />}
            <Modal
                state={showVideoPopup}
                title={"CCETC Startup video"}
                setState={toggleVideoPopup}
                style={{ width: "95%" }}
                bodyContent={
                    <Suspense fallback={<div>Loading video...</div>}>
                        <VideoModal />
                    </Suspense>
                }
            />
        </section>
    );
};

export default RDExhibit;

// REMOVED DATA FROM R&D JSON FILE

// {
//     "name": "Dr. Sabu M Thampi",
//     "designation": "Professor, School of CSE Coordinator - Connected Systems and Intelligence Lab",
//     "instituteName": "IIITM Kerala",
//     "projectTitle": "Novel Security Framework for Internet of Drones",
//     "instituteHomePage": "https://www.iiitmk.ac.in/"
// },
// {
//     "name": "Dr. Neminath Hubballi",
//     "designation": "Professor, Department of Computer Science and Engineering",
//     "instituteName": "IIT Indore",
//     "projectTitle": "Detecting Collusion and Data Manipulation Attacks in Smart-Grid Networks",
//     "instituteHomePage": "https://www.iiti.ac.in/"
// },
// {
//     "name": "Dr. Rajesh Kumar",
//     "designation": "Assistant Professor, Department of Computer Science & Information Systems",
//     "instituteName": "BITS Pilani (Goa Campus)",
//     "projectTitle": "Predictor and Analyzer of Security Threats (PAST): A Model-based Risk Analysis Framework for Critical Interconnected Infrastructures",
//     "instituteHomePage": "https://www.bits-pilani.ac.in/"
// },
// {
//     "name": "Dr. Harkeerat Kaur",
//     "designation": "Assistant Professor, Department of Computer Science and Engineering",
//     "instituteName": "IIT Jammu",
//     "projectTitle": "Smart Data Agent for Location Management and Privacy",
//     "instituteHomePage": "https://www.iitjammu.ac.in/"
// },
// {
//     "name": "Dr. Deepak Ronanki",
//     "designation": "Assistant Professor, Department of Engineering Design",
//     "instituteName": "IIT Madras",
//     "projectTitle": "Smart Cyber-Physical Security of Electric Powertrains in Autonomous e-Mobility Systems",
//     "instituteHomePage": "https://www.iitm.ac.in/"
// },

// REMOVED DATA FROM STARTUP JSON FILE

// {
//     "logo": "COSGrid.png",
//     "link": "https://www.cosgrid.com/"
// },
// {
//     "logo": "Xpanso.png",
//     "link": "https://www.cloudoptimo.com/"
// }
